import { useCallback } from 'react';

import { notifications } from '@mantine/notifications';

import { useAppDispatch } from '@/hooks/index';

import { setPasses } from '@/store/user-process/user-process';

import { useLazyGetPersonPassesQuery } from '@/api/passes';

import { AutorizationResponseType } from '@/types/authorization';

import { isModerator } from '@/shared/helpers/isAdmin';
import useUserStore from '@/shared/store/user.store.ts';

const usePassesCheckout = () => {
	const dispatch = useAppDispatch();

	const [getPersonPasses] = useLazyGetPersonPassesQuery();

	return useCallback(
		async (remember: boolean, user: AutorizationResponseType | null) => {
			const { setPasses: setZustandPasses, setIsModerator } = useUserStore.getState();

			try {
				if (!user) {
					throw new Error('Выполните повторный вход в систему');
				}

				const passes = await getPersonPasses(user?.user.person_id).unwrap();

				dispatch(setPasses(passes.objects));
				setZustandPasses(passes.objects);
				setIsModerator(Boolean(isModerator(passes.objects)));

				if (remember) {
					localStorage.setItem('passes', JSON.stringify(passes.objects));
				}
			} catch (e) {
				notifications.show({
					message: (e as Error)?.message,
					bg: '#ff0000',
					mah: '100%',
					maw: 'fit-content',
					mx: 'auto',
					radius: 12,
					autoClose: 5000,
					withCloseButton: false,
				});
				localStorage.removeItem('passes');
				setZustandPasses([]);
				setIsModerator(false);
			}
		},
		[dispatch, getPersonPasses],
	);
};

export default usePassesCheckout;
